import { render, staticRenderFns } from "./ExamQuestions.vue?vue&type=template&id=570b640e&"
import script from "./ExamQuestions.vue?vue&type=script&lang=js&"
export * from "./ExamQuestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports